import styled from "styled-components";

export const MainContainer = styled.div<{ $isExpanded: boolean; $isSideBarHidden: boolean }>`
	min-height: 100vh;
	background-color: ${({ theme }) => theme.body};
	display: grid;
	transition: grid-template-columns 200ms;
	grid-template-columns: ${({ $isExpanded, $isSideBarHidden }) =>
		$isSideBarHidden ? "0px 1fr" : $isExpanded ? "256px 1fr" : "92px 1fr"};
	grid-template-rows: auto 1fr;
	grid-template-areas:
		"sidebar header"
		"sidebar content";

    .childRoutesContainer {
        position: relative;
        grid-area: content;
        overflow: auto;

        > main {
            height: calc(100vh - 67px);
            padding: 1.6rem;
            overflow: auto;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
        }
    }
`;
